import { Autocomplete, TextField } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import { ProfessionModel } from "services/organizationPortalClient";
import contextStore from "stores/contextStore";
import { useIntl } from "react-intl";

type SelectCertificateProfessionProps = {
  value: string[];
  onChange: (v: string[]) => void;
};

const SelectCertificateProfession = ({
  onChange,
  value,
}: Readonly<SelectCertificateProfessionProps>) => {
  const { formatMessage: t } = useIntl();
  const { certificatesService } = useGlobalContext();
  const { organization } = contextStore.useState();

  const { data, isFetching } = useQuery(
    ["certificatesService.getProfessions", organization?.id],
    () => certificatesService.getProfessions(),
    { enabled: !!organization?.id }
  );

  const handleChangeMultiple = (_: any, values: ProfessionModel[]) => {
    onChange(values.map((v) => v.id).filter((id): id is string => !!id));
  };

  const options = [...(data?.data ?? [])].sort((a, b) =>
    (a.name ?? "").localeCompare(b.name ?? "")
  );

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option) => option.name ?? "?"}
      value={options.filter((r) => !!r.id && value.includes(r.id))}
      onChange={handleChangeMultiple}
      loading={isFetching}
      size="small"
      renderInput={(params) => (
        <TextField {...params} label={t({ id: "professions" })} size="small" />
      )}
    />
  );
};

export default SelectCertificateProfession;
